import axiosInstance from './axiosInstance'; 


const API_URL = 'https://idealonline.com.tr/service/idealonline/v1/';

//Yazar Oluştur
export const createAuthor = async (authorData,token) => {
  try {
    const response = await axiosInstance.post(`authors/CreateAuthors`, authorData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`, 
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating author:', error);
    throw error;
  }
};


//Yazarları listele
export const getAuthorsList = async (page, size, token) => {
    try {
      const response = await axiosInstance.get(`authors/AuthorsList/1`, {
        params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching authors list:", error);
      throw error;
    }
  };

  export const AuthorsInstList = async (page, size, token) => {
    try {
      const response = await axiosInstance.get(`authors/AuthorsInstList/1`, {
        params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching authors list:", error);
      throw error;
    }
  };
  

  export const updateAuthorDetails = async (id, data, token) => {
    try {
      const response = await axiosInstance.post(`authors/AuthorUpdate/${id}/1`, data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error updating author details:", error);
      throw error;
    }
  };
  
  export const deleteAuthor = async (id, token) => {
    try {
      const response = await axiosInstance.get(`authors/AuthorStatusUpdate/${id}/-1`,{
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting author:", error);
      throw error;
    }
  };


  export const saveAuthInst = async (instData, token) => {
    try {
      const response = await axiosInstance.post(`authors/saveAuthInst`, instData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error saving author institution:', error);
      throw error;
    }
  };

  export const getAuthorsInstList = async (page, size, token) => {
    try {
      const response = await axiosInstance.get(`authors/AuthorsInstList/1?page=${page}&size=${size}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching authors institution list:', error);
      throw error;
    }
  };

  export const getAuthorDetail = async (id, token) => {
    try {
      const response = await axiosInstance.get(`authors/search/authordetail/${id}/1`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Yazar kurumu detaylarını getirirken hata oluştu:', error);
      throw error;
    }
  };

  export const getInstDetail = async (id, token) => {
    return await axiosInstance.get(`authors/AuthorsInstDetail/${id}/1`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  export const getAuthorInstDetail = async (id, token) => {
    return await axiosInstance.get(`authors/AuthorsFullInfoDetail/${id}/1/1/1`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  export const saveAuthInstRegister = async (authid, authinstid, token) => {
    try {
      const response = await axiosInstance.post(
        `authors/saveAuthInstRegister`,
        {
          authid,
          authinstid
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching authors list:", error);
      throw error;
    }
  };
  
  export const getContactPerson = async (id,status, token) => {
    const response = await axiosInstance.get(`authorcontactperson/ListByAuthorId/${id}/${status}`,  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

  export const getauthorsauthorcustomerrep = async (id,status, token) => {
    const response = await axiosInstance.get(`authorcustomerrep/ListByAuthorId/${id}/${status}`,  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };
  
  export const getPublicationListByAuthorid = async (id, status, token) => {
    try {
      const response = await axiosInstance.get(`publications/ListByAuthorId/${id}/${status}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching Publishers list:", error);
      throw error;
    }
  };

    export const getPublicationListByAuthoridsearch = async (id, status, page, size, token) => {
    try {
      const response = await axiosInstance.get(`publications/search/ListByAuthorId/${id}/${status}`, {
        params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching Publishers list:", error);
      throw error;
    }
  };

  export const ListByPublisherIdsearch = async (id, status, page, size, token) => {
  try {
    const response = await axiosInstance.get(`publications/search/ListByPublisherId/${id}/${status}`, {
      params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Publishers list:", error);
    throw error;
  }
};

  export const getListByAuthoridPublisher = async (id, status, token) => {
    try {
      const response = await axiosInstance.get(`publishers/ListByAuthorid/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching Publishers list:", error);
      throw error;
    }
  };

  
export const ListByPublisherid = async (publisherid, page,size, token) => {
  try {
    const response = await axiosInstance.get(`authors/ListByPublisherid/${publisherid}`, {
      params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching authors list:", error);
    throw error;
  }
};

export const getAuthorTitleList = async (token) => {
  try {
    const response = await axiosInstance.get(`authors/getAuthorTitleList`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching getAuthorTitleList:", error);
    throw error;
  }
};

export const getLanguageAllList = async (token) => {
    try {
      const response = await axiosInstance.get(`systemsettings/languageAllList`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching getLanguageAllList:", error);
      throw error;
    }
  };

    export const templatesListAuthor = async (status, token,page,size) => {
    try {
      const response = await axiosInstance.get(`userpanel/templatesList/${status}`, {
        params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching authors list:", error);
      throw error;
    }
  };

    export const templatetypelistAuthor = async (status, token,page,size) => {
    try {
      const response = await axiosInstance.get(`userpanel/templatetypesList/${status}`, {
        params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`,
      }
      
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching authors list:", error);
      throw error;
    }
  };

    export const templatesandattributedataListAuthors = async (id,status, token) => {
    try {
      const response = await axiosInstance.get(`userpanel/templatesandattributedataList/${id}/${status}`, {
        //params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`,
      }
      
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching authors list:", error);
      throw error;
    }
  };

  
export const uniqueidSearch = async (uniqueid, token) => {
    try {
      const response = await axiosInstance.get(`userpanel/uniqueidSearch/${uniqueid}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching authors list:", error);
      throw error;
    }
  };

  
export const getAuthorUniversityList = async (token) => {
  try {
    const response = await axiosInstance.get(`userpanel/authorsuniversitylist/getAuthorUniversityList`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching getAuthorUniversityList:", error);
    throw error;
  }
};